import { __require as u } from "./main49.js";
var a, e;
function p() {
  if (e) return a;
  e = 1;
  var t = u();
  function i(r) {
    return t(this, r).has(r);
  }
  return a = i, a;
}
export {
  p as __require
};
